import { FAST_X_MOVIE_DETAIL } from './userPanelMovieDetailData';

const MOVIE_PREVIEW_RATINGS = {
  'Hızlı ve Öfkeli 10': '5.7',
  'Top Gun: Maverick': '8.2',
  'John Wick 4': '7.6',
  'Mad Max: Fury Road': '8.1',
  Inception: '8.8',
  Interstellar: '8.7',
  'Dune: Part Two': '8.5',
  'Avatar: The Way of Water': '7.5',
  Oppenheimer: '8.3',
  'The Godfather': '9.2',
  Parasite: '8.5',
  Joker: '8.3',
  Barbie: '6.8',
  'Everything Everywhere All at Once': '7.8',
  'The Grand Budapest Hotel': '8.1',
  'The Intouchables': '8.5',
  'A Quiet Place: Day One': '6.3',
  'The Conjuring': '7.5',
  It: '7.3',
  'Get Out': '7.8',
  'Inside Out 2': '7.5',
  'Spider-Man: Across the Spider-Verse': '8.6',
  Coco: '8.4',
  'The Wild Robot': '8.2',
};

export const MOVIE_CATEGORIES = [
  {
    id: 'action',
    name: 'Aksiyon',
    mark: 'AK',
    color: '#ff8a1f',
    rgb: '255, 138, 31',
    movies: [
      FAST_X_MOVIE_DETAIL,
      { title: 'Top Gun: Maverick', year: '2022', poster: 'https://image.tmdb.org/t/p/w500/62HCnUTziyWcpDaBO2i1DX17ljH.jpg' },
      { title: 'John Wick 4', year: '2023', poster: 'https://image.tmdb.org/t/p/w500/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg' },
    ],
  },
  {
    id: 'science-fiction',
    name: 'Bilim Kurgu',
    mark: 'BK',
    color: '#18a9e6',
    rgb: '24, 169, 230',
    movies: [
      { title: 'Inception', year: '2010', poster: 'https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg' },
      { title: 'Interstellar', year: '2014', poster: 'https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg' },
    ],
  },
  {
    id: 'adventure',
    name: 'Macera',
    mark: 'MC',
    color: '#f38a3f',
    rgb: '243, 138, 63',
    movies: [
      { title: 'Mad Max: Fury Road', year: '2015', poster: 'https://image.tmdb.org/t/p/w500/hA2ple9q4qnwxp3hKVNhroipsir.jpg' },
      { title: 'Dune: Part Two', year: '2024', poster: 'https://image.tmdb.org/t/p/w500/1pdfLvkbY9ohJlCjQH2CZjjYVvJ.jpg' },
      { title: 'Avatar: The Way of Water', year: '2022', poster: 'https://image.tmdb.org/t/p/w500/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg' },
    ],
  },
  {
    id: 'drama',
    name: 'Dram',
    mark: 'DR',
    color: '#a576ff',
    rgb: '165, 118, 255',
    movies: [
      { title: 'Oppenheimer', year: '2023', poster: 'https://image.tmdb.org/t/p/w500/8Gxv8gSFCU0XGDykEGv7zR1n2ua.jpg' },
      { title: 'The Godfather', year: '1972', poster: 'https://image.tmdb.org/t/p/w500/3bhkrj58Vtu7enYsRolD1fZdja1.jpg' },
      { title: 'Parasite', year: '2019', poster: 'https://image.tmdb.org/t/p/w500/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg' },
    ],
  },
  {
    id: 'thriller',
    name: 'Gerilim',
    mark: 'GR',
    color: '#d94a72',
    rgb: '217, 74, 114',
    movies: [
      { title: 'Joker', year: '2019', poster: 'https://image.tmdb.org/t/p/w500/udDclJoHjfjb8Ekgsd4FDteOkCU.jpg' },
      { title: 'A Quiet Place: Day One', year: '2024', poster: 'https://image.tmdb.org/t/p/w500/yrpPYKijwdMHyTGIOd1iK1h0Xno.jpg' },
      { title: 'Get Out', year: '2017', poster: 'https://image.tmdb.org/t/p/w500/tFXcEccSQMf3lfhfXKSU9iRBpa3.jpg' },
    ],
  },
  {
    id: 'comedy',
    name: 'Komedi',
    mark: 'KM',
    color: '#e7c928',
    rgb: '231, 201, 40',
    movies: [
      { title: 'Barbie', year: '2023', poster: 'https://image.tmdb.org/t/p/w500/iuFNMS8U5cb6xfzi51Dbkovj7vM.jpg' },
      { title: 'Everything Everywhere All at Once', year: '2022', poster: 'https://image.tmdb.org/t/p/w500/w3LxiVYdWWRvEVdn5RYq6jIqkb1.jpg' },
      { title: 'The Grand Budapest Hotel', year: '2014', poster: 'https://image.tmdb.org/t/p/w500/eWdyYQreja6JGCzqHWXpWHDrrPo.jpg' },
      { title: 'The Intouchables', year: '2011', poster: 'https://image.tmdb.org/t/p/w500/1QU7HKgsQbGpzsJbJK4pAVQV9F5.jpg' },
    ],
  },
  {
    id: 'horror',
    name: 'Korku',
    mark: 'KR',
    color: '#d93668',
    rgb: '217, 54, 104',
    movies: [
      { title: 'The Conjuring', year: '2013', poster: 'https://image.tmdb.org/t/p/w500/wVYREutTvI2tmxr6ujrHT704wGF.jpg' },
      { title: 'It', year: '2017', poster: 'https://image.tmdb.org/t/p/w500/9E2y5Q7WlCVNEhP5GiVTjhEhx1o.jpg' },
    ],
  },
  {
    id: 'animation',
    name: 'Animasyon',
    mark: 'AN',
    color: '#20bd79',
    rgb: '32, 189, 121',
    movies: [
      { title: 'Inside Out 2', year: '2024', poster: 'https://image.tmdb.org/t/p/w500/vpnVM9B6NMmQpWeZvzLvDESb2QY.jpg' },
      { title: 'Spider-Man: Across the Spider-Verse', year: '2023', poster: 'https://image.tmdb.org/t/p/w500/8Vt6mWEReuy4Of61Lnj5Xj704m8.jpg' },
      { title: 'Coco', year: '2017', poster: 'https://image.tmdb.org/t/p/w500/gGEsBPAijhVUFoiNpgZXqRVWJt2.jpg' },
      { title: 'The Wild Robot', year: '2024', poster: 'https://image.tmdb.org/t/p/w500/wTnV3PCVW5O92JMrFvvrRcV39RU.jpg' },
    ],
  },
];

export const MOVIE_LIBRARY = MOVIE_CATEGORIES.flatMap((category) => (
  category.movies.map((movie, index) => ({
    id: movie.id || `${category.id}-${index + 1}`,
    stream_id: movie.stream_id || `${category.id}-${index + 1}`,
    name: movie.title,
    title: movie.title,
    originalTitle: movie.originalTitle || '',
    year: movie.year,
    rating: movie.rating || MOVIE_PREVIEW_RATINGS[movie.title] || '',
    yorum_sayisi: movie.yorum_sayisi ?? 2,
    genre: category.name,
    category_id: category.id,
    categoryId: category.id,
    categoryName: category.name,
    categoryMark: category.mark,
    categoryColor: category.color,
    categoryRgb: category.rgb,
    poster: movie.poster,
    stream_icon: movie.poster,
    backdrop: movie.backdrop || '',
    backdropUrl: movie.backdrop || '',
    tagline: movie.tagline || '',
    runtime: movie.runtime || '',
    certification: movie.certification || '',
    overview: movie.overview || '',
    description: movie.overview || '',
    director: movie.director || '',
    cast: movie.cast || [],
    genres: movie.genres || [category.name],
    posterFit: movie.posterFit || 'cover',
  }))
));
